import React, { useState, useEffect } from "react";
import { Icons, Box, Stack } from "@curves/ui-base";
import BarcodeScannerDialog from "@icoach/pos/dialog/BarcodeScannerDialog";
import { isFunction } from "@util/utils";

/**
 * 商品掃描輸入組件
 * 提供商品掃描和手動輸入功能
 * @param {Object} props - 組件屬性
 * @param {Function} props.handleScanResult - 掃描結果處理函數
 * @param {string} [props.placeholder] - 佔位符文字
 * @param {string} [props.className] - 自定義樣式類名
 * @param {Function} [props.onDialogStateChange] - 對話框狀態變化回調 (dialogName, isOpen)
 */
const PRODUCT_SCAN_DIALOG = "ProductScanDialog";

const ProductScanInput = ({ handleScanResult, placeholder = "掃描商品SKU或手動輸入", className = "", onDialogStateChange }) => {
	const [showScanDialog, setShowScanDialog] = useState(false);

	// 處理對話框打開
	const handleOpenDialog = () => {
		setShowScanDialog(true);
		if (isFunction(onDialogStateChange)) {
			onDialogStateChange(PRODUCT_SCAN_DIALOG, true);
		}
	};

	// 處理對話框關閉
	const handleCloseDialog = () => {
		setShowScanDialog(false);
		if (isFunction(onDialogStateChange)) {
			onDialogStateChange(PRODUCT_SCAN_DIALOG, false);
		}
	};

	// 同步狀態：通知父組件對話框狀態變化
	useEffect(() => {
		if (isFunction(onDialogStateChange)) {
			onDialogStateChange(PRODUCT_SCAN_DIALOG, showScanDialog);
		}
	}, [showScanDialog, onDialogStateChange]);

	const handleScanSuccess = sku => {
		// 如果是清除操作（null），不處理
		if (sku === null) {
			return;
		}

		return isFunction(handleScanResult) ? handleScanResult(sku) : false;
	};

	const handleScanError = error => {
		console.error("商品掃描錯誤:", error);
	};

	return (
		<>
			{/* 掃描觸發按鈕 */}
			<Stack
				className={`pos-scan-trigger ${className}`}
				alignItems="center"
				spacing={2}
				onClick={handleOpenDialog}
				style={{
					padding: "8px 16px",
					borderRadius: "4px",
					backgroundColor: "#fff",
					cursor: "pointer",
				}}
			>
				<Icons.CarrierCode style={{ color: "#666" }} />
				<Box style={{ color: "#999" }}>{placeholder}</Box>
			</Stack>

			{/* 掃描彈窗 */}
			<BarcodeScannerDialog
				title="商品掃描"
				open={showScanDialog}
				onClose={handleCloseDialog}
				onScanSuccess={handleScanSuccess}
				onScanError={handleScanError}
				placeholder={placeholder}
				continuousScan
			/>
		</>
	);
};

export default ProductScanInput;
